import { useRef } from 'react'

import { EMPTY_LIST } from '../../../../../constants/common'
import {
  getBirdviewLayoutCollisions,
  getBirdviewLayoutWithMovedWidget,
  getBirdviewLayoutWithSortedColumn,
  getBirdviewOverColumn,
} from '../../BirdviewLayout.utils'

export function useBirdviewLayoutDrag({ layout, setLayout }) {
  const layoutBeforeDragRef = useRef(null)
  const lastCollisionsRef = useRef(EMPTY_LIST)

  // A cross-column move is applied on drag-over, so a cancelled drag has to
  // restore the layout the drag started from.
  function handleDragStart() {
    layoutBeforeDragRef.current = layout
    lastCollisionsRef.current = EMPTY_LIST
  }

  // Over the gap between the columns nothing is under the pointer, so the drag
  // keeps its last target.
  function detectCollisions(args) {
    const collisions = getBirdviewLayoutCollisions(args)

    if (collisions.length > 0) {
      lastCollisionsRef.current = collisions
    }

    return lastCollisionsRef.current
  }

  function restoreLayoutBeforeDrag() {
    setLayout(prev => layoutBeforeDragRef.current ?? prev)
  }

  function handleDragCancel() {
    restoreLayoutBeforeDrag()

    layoutBeforeDragRef.current = null
  }

  function handleDragOver({ active, over }) {
    const overColumn = getBirdviewOverColumn(over)

    if (overColumn) {
      setLayout(prev =>
        getBirdviewLayoutWithMovedWidget({
          activeId: active.id,
          layout: prev,
          over,
          overColumn,
        })
      )
    }
  }

  function handleDragEnd({ active, over }) {
    const overColumn = getBirdviewOverColumn(over)

    if (overColumn) {
      setLayout(prev =>
        getBirdviewLayoutWithSortedColumn({
          activeId: active.id,
          layout: prev,
          over,
          overColumn,
        })
      )
    } else {
      restoreLayoutBeforeDrag()
    }

    layoutBeforeDragRef.current = null
  }

  return {
    detectCollisions,
    handleDragCancel,
    handleDragEnd,
    handleDragOver,
    handleDragStart,
  }
}
